export default "/images/vendor/@coreui/icons/svg/flag/cif-pk.svg?727d4e7dfb68f1cce4eaab41a26626d5";